export default __webpack_public_path__ + "static/media/num-5.5b9555cd.svg";